<template>
  <div class="card shadow p-3">
    <div class="card-header border-0 bg-transparent">
      <base-title
        :title="title"
        popover="Listado de visitas recibidas a esta empresa"
      >
        <template slot="button">
          <b-button
            @click="$refs.updateReward.show()"
            size="sm"
            variant="outline-primary"
            >{{ $t("update-reward-rate") }}</b-button
          >
        </template>
      </base-title>
    </div>
    <b-row>
      <b-col md="2">
        <b-form-select
          v-if="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? false
              : true
          "
          v-model="perPage"
          :options="[5, 10, 20, 100]"
          @input="changePerPage"
          size="sm"
          class="mt-2"
        ></b-form-select>
      </b-col>
      <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
        <b-form-group>
          <b-input-group>
            <b-form-input
              v-if="
                !Array.isArray(tableData.data) || tableData.data.length === 0
                  ? false
                  : true
              "
              class="form-control-sm"
              v-model="searchData"
              type="search"
              :placeholder="$t('search')"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="tableData.data"
          :fields="columns"
          :per-page="tableData.per_page"
          :current-page="tableData.current_page"
          :busy="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? true
              : false
          "
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(amount)="data">
            <span>{{ data.item.amount }} MP.</span>
          </template>
          <template v-slot:cell(date)="data">
            <span
              >{{ moment(data.item.date).format("DD-MM-YYYY H:m") }} hrs.</span
            >
          </template>
          <template v-slot:cell(status)="data">
            <b-badge
              class="text-white"
              size="lg"
              :class="
                data.item.visit.is_approved == 2
                  ? 'bg-info'
                  : data.item.visit.is_approved == 0
                  ? 'bg-danger'
                  : 'bg-success'
              "
              >{{
                data.item.visit.is_approved == 2
                  ? $t("pending")
                  : data.item.visit.is_approved == 0
                  ? $t("rejected")
                  : $t("approved")
              }}
            </b-badge>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              v-if="data.item.visit.is_approved == 2"
              v-b-tooltip.hover
              :title="$t('approve')"
              variant="success"
              size="sm"
              @click="
                savePayment({ visit_id: data.item.visit.id, is_approved: 1 })
              "
              ><i class="ni ni-check-bold"></i
            ></b-button>
            <b-button
              v-if="data.item.visit.is_approved == 2"
              v-b-tooltip.hover
              @click="
                savePayment({ visit_id: data.item.visit.id, is_approved: 0 })
              "
              :title="$t('reject')"
              variant="danger"
              size="sm"
              ><i class="ni ni-fat-remove"></i
            ></b-button>
          </template>
        </b-table>
        <b-pagination
          v-if="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? false
              : true
          "
          class="mt-3"
          v-model="tableData.current_page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
    <ModalsRewardRate ref="updateReward" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import _ from "lodash";
import moment from "moment";
import ModalsRewardRate from "../Visits/Modals/UpdateRewardRate.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "visits-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  components: {
    ModalsRewardRate,
  },
  async created() {
    await this.search();
    this.debouncedGetAnswer = _.debounce(this.search, 500);
    this.perPage = this.tableData.per_page;
  },
  watch: {
    searchData: function (newQuestion, oldQuestion) {
      this.debouncedGetAnswer();
    },
  },
  data() {
    return {
      dataCategory: {},
      perPage: 5,
      currentPage: 1,
      searchData: "",
      moment,
    };
  },
  methods: {
    ...mapActions({
      getVisitsToCompany: "company/getVisitsToCompany",
      processPayments: "company/processPayments",
      processVisits: "company/processVisits",
    }),
    async savePayment({ visit_id, is_approved }) {
      await Swal.fire({
        title: this.$t("are_you_sure?"),
        text: this.$t(
          is_approved === 1
            ? "question_approve_visits"
            : "question_rejected_visits"
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await this.processVisits({ visit_id, is_approved });
            await this.search();
            this.$toast.success(res.message, {
              position: "top-right",
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    async search() {
      await this.getVisitsToCompany({
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.searchData,
        company_id: this.$route.params.id,
      });
    },
    async changePage(value) {
      this.currentPage = value;
      await this.debouncedGetAnswer();
    },
    async changePerPage() {
      await this.debouncedGetAnswer();
    },
  },
  computed: {
    ...mapGetters({
      tableData: "company/getVisitsCompany",
    }),
    columns() {
      return [
        {
          label: this.$t("nickname"),
          key: "visit.user.nickname",
          class: "text-center",
        },
        { label: this.$t("amount"), key: "amount", class: "text-center" },
        { label: this.$t("date"), key: "date", class: "text-center" },
        { label: this.$t("status"), key: "status", class: "text-center" },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
  },
};
</script>